'use client'
import { Badge as ChakraBadge } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { BadgeProps } from './Badge.types'

export default forwardRef(function Badge(
  props: BadgeProps,
  ref: LegacyRef<HTMLHRElement>
) {
  return <ChakraBadge {...props} ref={ref} translate="no" />
})
